<section class="section-cart p-3 pt-4 w-100 d-flex" appScrollTop>
    <div class="section-cart-container w-100">
        <app-breadcrumbs class="breadcrumbs" />
        @if (!showBreadcrumb) {
            <app-back-button [url]="chargesURL" class="back-button"> BACK </app-back-button>
        }
        @if ((cartBill.cartBillResponseDTOList.length || 0) > 0) {
            @if (cartHasMessageSignal()) {
                <lib-banner [banner]="banner" class="mt-3" />
            }
            <h1 class="title mat-headline-5 mt-4 mb-3">Cart</h1>
            <div class="d-flex flex-column flex-lg-row">
                <mat-card appearance="raised" class="col-12 col-lg-7 ds-migration">
                    @if (!collectCompanyInformationByPayment) {
                        <ng-container [ngTemplateOutlet]="customerReference" />
                    }
                    <div class="d-flex justify-content-between mat-headline-6">
                        <div>Amount</div>
                        <div>USD {{ subtotal | currency }}</div>
                    </div>
                    @if (hasBelowThreshold) {
                        <ng-container
                            [ngTemplateOutlet]="paymentMethods"
                            [ngTemplateOutletContext]="{ title: 'Payment method:', isAboveThreshold: false }"
                        />
                        <ng-container
                            [ngTemplateOutlet]="itemsInCart"
                            [ngTemplateOutletContext]="{ isAboveThreshold: false }"
                        />
                        @if (underLimitDisclaimer) {
                            <div
                                class="mat-subtitle-1 m-0 d-block text-start mb-4 lending-disclaimer"
                                [innerHTML]="underLimitDisclaimer"
                            ></div>
                        }
                    }
                    @if (hasAboveThreshold) {
                        <mat-divider class="m-divider mb-2" />
                        <ng-container
                            [ngTemplateOutlet]="paymentMethods"
                            [ngTemplateOutletContext]="{ title: 'Payment method', isAboveThreshold: true }"
                        />
                        <ng-container
                            [ngTemplateOutlet]="itemsInCart"
                            [ngTemplateOutletContext]="{ isAboveThreshold: true }"
                        />
                        @if (overLimitDisclaimer) {
                            <div
                                class="mat-subtitle-1 m-0 d-block text-start lending-disclaimer"
                                [innerHTML]="overLimitDisclaimer"
                            ></div>
                        }
                    }
                </mat-card>
                <div class="col-12 col-lg-5 ps-0 ps-lg-3">
                    <app-lib-balance
                        class="col-12"
                        [titleCustomFees]="titleCustomFees"
                        [cartNote]="cartNote"
                        [customSubtotal]="customSubtotal"
                        [customSubtotalTitle]="customSubtotalTitle"
                        [convenienceFees]="convenienceFees"
                        [termsOfUseURL]="termsOfUseURL"
                        [cartNoteWithCheckbox]="cartNoteWithCheckbox"
                        [isAllowedMultipleAWBs]="isAllowedMultipleAWBs"
                    >
                        @if (!isAuthenticated) {
                            <div slot="after-pay-button" class="mt-3">
                                <button mat-button color="primary" (click)="backToLogin()" class="p-0 w-100">
                                    SPRINTPAY LOGIN
                                </button>
                            </div>
                        }
                    </app-lib-balance>
                </div>
            </div>
        }
        <ng-template #customerReference>
            <!-- Customer Reference Section -->
            <mat-card-title class="mat-headline-6 mb-2"
                >Customer reference:&nbsp;
                <mat-icon class="md-icon-16" [matTooltip]="helpInformation" matTooltipPosition="after" color="primary">
                    info
                </mat-icon>
            </mat-card-title>
            <app-customer-reference-form />
            <mat-divider class="mt-2 mb-4" />
        </ng-template>
        <ng-template #paymentMethods let-title="title" let-isAboveThreshold="isAboveThreshold">
            <section class="ps-3">
                @if (isAccountOnHold) {
                    <app-account-on-hold />
                } @else {
                    @if (isAuthenticated) {
                        <app-cart-payment-methods [aboveThreshold]="isAboveThreshold"></app-cart-payment-methods>
                    } @else {
                        <app-guest-payment-method />
                    }
                }
            </section>
            <mat-divider class="mt-3 mb-2" />
        </ng-template>
        <ng-template #itemsInCart let-isAboveThreshold="isAboveThreshold">
            <app-cart-items [aboveThreshold]="isAboveThreshold" />
        </ng-template>

        @if (!isCartLoading && !cartBill.cartBillResponseDTOList.length) {
            <app-empty-cart class="p-5" [emptyCartMessage]="emptyCartMessage" />
        }
        @if (isCartLoading && !cartBill.cartBillResponseDTOList.length) {
            <div class="cart-loader">
                <mat-spinner diameter="36" />
            </div>
        }
    </div>
</section>
